import { render, staticRenderFns } from "./user_order_qx.vue?vue&type=template&id=25dd53fe&scoped=true"
import script from "./user_order_qx.vue?vue&type=script&lang=js"
export * from "./user_order_qx.vue?vue&type=script&lang=js"
import style0 from "./user_order_qx.vue?vue&type=style&index=0&id=25dd53fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd53fe",
  null
  
)

export default component.exports